import Player from '@vimeo/player';

const heroBlocks = [];
const videos = document.querySelectorAll(
	'.block-hero-display [data-vimeo-url]'
);

const vimeoPlayer = () => {
	if (videos.length) {
		videos.forEach((video) => {
			const parentBlock = video.closest('.block-hero-display');
			if (parentBlock) {
				heroBlocks.push(video.closest('.block-hero-display'));
			}
			const player = new Player(video);
			player.setQuality('720p');
			player.on('play', function () {
				player.element.parentElement.classList.add('loaded');
			});
			Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then(
				function (dimensions) {
					parentBlock.style.setProperty(
						'--videoRatio',
						`${dimensions[0] / dimensions[1]}`
					);
				}
			);
		});
	}
};

const setVideoSize = () => {
	if (heroBlocks.length) {
		heroBlocks.forEach((heroBlock) => {
			heroBlock.style.setProperty(
				'--blockHeight',
				`${heroBlock.offsetHeight / 16}rem`
			);
		});
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		vimeoPlayer();
		setVideoSize();
	},
	loaded() {},
	resized() {
		setVideoSize();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
